import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export default class Cancel extends PureComponent {
  render () {
    return (
      <button className={`button button-cancel button-icon ${this.props.className}`} onClick={this.props.onClick}>
        <FontAwesomeIcon icon={faTimes} />
      </button>
    );
  }
}

Cancel.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string
};

Cancel.defaultProps = {
  className: ''
};



// WEBPACK FOOTER //
// ./src/components/common/forms/buttons/Cancel/index.js